import React from 'react'
import { Modal, Button } from 'semantic-ui-react'

/**
 *
 * @callback SemanticUIEventHandler
 * @param {*} event
 * @param {*} data
 */

/**
 *
 * @param {object} props
 * @param {SemanticUIEventHandler} props.close
 * @param {SemanticUIEventHandler} props.onTransferOwnership
 * @param {boolean} props.loading
 * @param {object} props.newOwner
 */
export default function TransferOwnershipModalContent({
  close,
  onTransferOwnership,
  loading,
  newOwner,
}) {
  return (
    <React.Fragment>
      <Modal.Header>Transfer ownership</Modal.Header>
      <Modal.Content>
        <p>
          You're about to make <strong>{newOwner.name || newOwner.email}</strong> the owner of your
          Simplesat account.
        </p>
        <p>
          To undo this action you'll need to contact them to transfer the ownership back to you.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button negative onClick={onTransferOwnership} loading={loading} disabled={loading}>
          Transfer ownership
        </Button>
      </Modal.Actions>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/TransferOwnershipModalContent/index.js